import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {
  Configurator,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorCommonsService,
  ConfiguratorStorefrontUtilsService,
  ConfiguratorUISettingsConfig,
} from '@spartacus/product-configurator/rulebased';
import {
  CpsConfiguratorFormValidationService,
  FeatureTogglesService,
  StepInputService,
  ValidationService,
} from '../../services';
import {DcpConfiguratorAttributeQuantityComponent} from '../dcp-configurator-attribute-quantity/dcp-configurator-attribute-quantity.component';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator-attribute-spend-amount',
  templateUrl: './dcp-configurator-attribute-spend-amount.component.html',
  styleUrls: ['./dcp-configurator-attribute-spend-amount.component.scss'],
  standalone: false,
})
export class DcpConfiguratorAttributeSpendAmountComponent
  extends DcpConfiguratorAttributeQuantityComponent
  implements OnInit, OnDestroy
{
  constructor(
    public override validationService: ValidationService,
    protected override config: ConfiguratorUISettingsConfig,
    protected override configCommonsService: ConfiguratorCommonsService,
    protected override stepInputService: StepInputService,
    protected override configuratorFormValidationService: CpsConfiguratorFormValidationService,
    protected override featureTogglesService: FeatureTogglesService,
    protected configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    protected override configuratorStorefrontUtilsService: ConfiguratorStorefrontUtilsService,
  ) {
    super(
      validationService,
      config,
      configCommonsService,
      stepInputService,
      configuratorFormValidationService,
      featureTogglesService,
      configuratorAttributeCompositionContext,
      configuratorStorefrontUtilsService,
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override loadQuantityMetaData(instanceGroup: Configurator.Group) {
    this.quantityMetaData = {
      interval: 1,
      min: this.getMinFromEntryFieldMask(),
      max: this.defaultMetaData.max,
      salesMetric: super.getSalesMetric(instanceGroup),
      salesMetricTooltip: super.getSalesMetricDescription(instanceGroup),
    };
  }

  override ngOnDestroy(): void {
    this.configuratorFormValidationService.unregisterFormControl(this.attributeInputForm);
  }

  override setErrorMessage(): void {
    if (this.hasError()) {
      const error = Object.keys(this.attributeInputForm.errors ?? {})[0];
      this.errorMessage = `configurator.spendamount.${this.fieldNameParser(error)}`;
    } else {
      this.errorMessage = 'configurator.error.noError';
    }
  }

  override getTranslationValues(): number {
    const translation = this.errorMessage;
    if (translation === 'configurator.spendamount.minimum') {
      return this.quantityMetaData?.min ?? 0;
    }
    if (translation === 'configurator.spendamount.maximum') {
      return this.quantityMetaData?.max ?? 0;
    }
    if (translation === 'configurator.spendamount.step') {
      return this.quantityMetaData?.interval ?? 0;
    }
    return 0;
  }

  protected override setValue() {
    if (this.attribute.selectedSingleValue) {
      this.attributeInputForm.setValue(this.attribute.selectedSingleValue, {
        emitEvent: false,
      });
    } else {
      this.attributeInputForm.setValue(this.quantityMetaData?.min, {
        emitEvent: false,
      });
    }
  }

  private getMinFromEntryFieldMask() {
    let minimumSpendAmount = parseInt(this.attribute?.entryFieldMask ?? '', 10);
    if (isNaN(minimumSpendAmount)) {
      minimumSpendAmount = 1;
    }
    return minimumSpendAmount;
  }
}
